import { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import logo from '../../../../assets/images/logo.svg'
import savedIcon from '../../../../assets/icons/saved.svg'
import teamDashboard from '../../../../assets/icons/team-dashboard.svg'
import viewAgenda from '../../../../assets/icons/view-agenda.svg'
import docsAdd from '../../../../assets/icons/docs-add.svg'
import SearchInput from '../../search-input'
import './styles.sass'
import { UserdataContext } from '../../../../App'
import { parseJwt } from '../../../../insfrastructure/utils/JWTParser'
import { getAuthToken, clearAllTokens } from '../../../../insfrastructure/services/token-manager'


export const MobileHeader = () => {
    const [openedMenu, setOpenedMenu] = useState<boolean>(false)
  
    useEffect(() => {
      const handleDocumentClick = (e: MouseEvent) => {
        const target = e.target as HTMLElement;
        const menuBtn = document.querySelector('.menu-btn') as HTMLElement;
        const searchInput = document.querySelector('.oportunities-searcher') as HTMLElement;

        if (searchInput && searchInput.contains(target) && target.className !== 'search-icon') return;

        if (menuBtn && menuBtn.contains(target)) {
          setOpenedMenu(prev => !prev);
        } else {
          setOpenedMenu(false);
        }
      };

      document.addEventListener('click', handleDocumentClick);
      return () => document.removeEventListener('click', handleDocumentClick);
    }, [])
  
    return (
      <header className='mobile'>
        <div className={'menu-btn '+(openedMenu ? 'opened' : '')}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <Link to=''><img className='logo' alt='logo' src={logo} /></Link>
        <Menu openedMenu={openedMenu} />
      </header>
    )
}
  
const Menu = ({ openedMenu }: { openedMenu: boolean }) => {
    const navigate = useNavigate()
    const {userData, setUserData} = useContext<any>(UserdataContext)
    const usertypes: any = {
      'candidate': 'Candidato',
      'job_manager': 'Empresa'
    }

    // Verifica se o usuário tem perfil em_job_manager (bloqueio temporário)
    const hasEmJobManager = () => {
      try {
        const token = getAuthToken();
        if (!token) return false;
        const parsedJWT = parseJwt(token);
        return parsedJWT?.profiles?.includes('em_job_manager') || false;
      } catch (error) {
        return false;
      }
    }

    const onLogout = () => {
      clearAllTokens();
      setUserData(null);
      navigate('/login');
    }
  
    return (
      <div className={'menu '+(openedMenu ? 'opened' : '')}>
        {
          userData &&
          <div className='user-data'>
            <div>
              <h4>Olá, <b>{userData.full_name}</b></h4>
              <p>{usertypes[userData.usertype]}</p>
            </div>
            <div className='profile-picture-container'>
              {userData.picture && <img src={userData.picture} alt='user-picture' />}
            </div>
          </div>
        }
        {!userData &&
        <ul className='unlogged-links'>
          <Link to='sign-up'><li>Cadastro</li></Link>
          <Link to='login'><li>Entre</li></Link>
        </ul>}
        {userData?.usertype === 'candidate' &&
        <SearchInput />}
        <ul className='home-links'>
          <Link to='how-to-anounce'>
            <li>Como anunciar</li>
          </Link>
          <Link to='about-us'>
            <li>Sobre nós</li>
          </Link>
          <Link to='success-stories'>
            <li>Histórias</li>
          </Link>
        </ul>
        {userData?.usertype === 'candidate' &&
        <ul className='offer-links'>
          <Link to='offers'>
            <li>
              <span>Vagas</span>
            </li>
          </Link>
          <Link to='profile/candidate/subscriptions'>
            <li>
              <span>Vagas salvas</span>
            </li>
          </Link>
          <Link to='job-subscriptions'>
            <li>
              <span>Candidaturas</span>
            </li>
          </Link>
        </ul>}
        {userData?.usertype === 'job_manager' &&
        <ul className='offer-links'>
          <Link to='offers/create'>
            <li>
              <img src={docsAdd} alt='docs-add-icon' />
              <span>Publicar vaga</span>
            </li>
          </Link>
          <Link to='offers/panel'>
            <li>
              <img src={teamDashboard} alt='team-dashboard-icon' />
              <span>Minhas vagas</span>
            </li>
          </Link>
          <Link to='offers'>
            <li>
              <img src={viewAgenda} alt='view-agenda-icon' />
              <span>Vagas</span>
            </li>
          </Link>
        </ul>}
        {
          userData &&
          <ul>
            {!hasEmJobManager() && (
              <Link to={
                userData.usertype === 'candidate' 
                  ? 'profile/candidate/person' 
                  : userData.usertype === 'job_manager'
                    ? 'profile/job-manager'
                    : 'profile/company/user'
              }><li>Meu perfil</li></Link>
            )}
            <li onClick={onLogout}>Sair</li>
          </ul>
        }
      </div>
    )
}
  